import React from 'react';

/**
 * KinAdminMemberPositions
 *
 * KC-only table showing each member's current position in the Kin.
 *
 * Receives the members array from the parent (admin page) so we don't
 * fetch the funding data twice.
 */
export default function KinAdminMemberPositions({ members }) {
  const fmt = (n) => '$' + (Number(n) || 0).toFixed(2);

  if (!members || members.length === 0) {
    return (
      <p className="text-sm text-gray-500">No member activity yet.</p>
    );
  }

  return (
    <table className="min-w-full divide-y divide-gray-200">
      <thead className="bg-gray-50">
        <tr>
          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
            Member
          </th>
          <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">
            Available
          </th>
          <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">
            Pending
          </th>
          <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">
            Security Deposit
          </th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200">
        {members.map((m) => (
          <tr key={m.memberId} className="hover:bg-gray-50">
            <td className="px-4 py-3">
              <div className="font-medium">
                {m.name}
                {m.isViewer && (
                  <span className="ml-2 text-xs text-blue-600 font-normal">
                    (you)
                  </span>
                )}
              </div>
              {m.email && (
                <div className="text-xs text-gray-500">{m.email}</div>
              )}
            </td>
            <td className="px-4 py-3 text-right font-medium text-green-700">
              {fmt(m.available)}
            </td>
            <td className="px-4 py-3 text-right text-amber-700">
              {m.pendingPledge > 0 ? fmt(m.pendingPledge) : '—'}
              {m.pendingCount > 0 && (
                <div className="text-xs text-gray-500">({m.pendingCount})</div>
              )}
            </td>
            <td className="px-4 py-3 text-right text-amber-800">
              {m.securityDeposit > 0 ? fmt(m.securityDeposit) : '—'}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
